import { UntypedFormGroup } from '@angular/forms';
export interface recoverBySecurityQuestions {
  answer1Label: string;
  answer1Text: string;
  answer2Label: string;
  answer2Text: string;
  contentBodyHeader: string;
  defaultSelectValue: string;
  headerSubTitle: string;
  headerTitle: string;
  nextDisplayView: {
    button_continue: string;
    button_createPassword: string;
    button_forgotPassword: string;
    button_loginHelp: string;
    button_modal: string;
    button_resetPassword: string;
    button_sendLogin: string;
    button_wfp: string;
    nextViewName: string;
    nextViewName_createPassword: string;
    nextViewName_email: string;
    nextViewName_forgotPassword: string;
    nextViewName_loginHelp: string;
    nextViewName_resetPassword: string;
    nextViewName_sendLogin: string;
    nextViewName_sqa: string;
    overlayMessage: string;
    refreshUrl: string;
  };
  question1Label: string;
  question2Label: string;
  viewName: string;
  pageHeader: pageHeader;
  errors: RecoverSQAErrorMessages;
}

export interface sqaContent {
  formGroup: UntypedFormGroup;
  sqaStoredQuestionList: storedQuestionsContent;
  sqaFormAttributes: sqaFormAttributes;
  pageContent: recoverBySecurityQuestions;
  disableButton: boolean;
  errorCode?: string | undefined;
}

export interface storedQuestionsContent {
  errors?: {
    code: string;
  }[];
  securityQuestionList?: {
    currentIndicator: string;
    questionNumber: string;
    questionText: string;
  }[];
  formNameSubmitted: string;
}

export interface pageHeader {
  altText: string;
  logoUrl: string;
  headerTitle: string;
  headerSubTitle: string;
}

export interface validateAnswerRequest {
  tlMaskInfo_answer1?: string;
  tlMaskInfo_answer2?: string;
  securityQuestionNbr1: string;
  securityQuestionNbr2: string;
  formNameSubmitted: string;
}

export interface validateQuestionAnswer {
  securityQuestionNbr1: string;
  securityQuestionNbr2: string;
}

export interface RecoverSQAErrorMessages {
  answer1ErrorMessage: string;
  answer2ErrorMessage: string;
  alertWarningErrorMessages: string;
  formAlertErrorMessage?: string;
}
export interface sqaFormAttributes {
  errorCount?: number;
  submitAttempt?: boolean;
  errorAlertBanner: boolean;
  answer1ControlTouched: boolean;
  answer2ControlTouched: boolean;
}
